// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { initialize } from 'redux-form'
import { getInitialValues } from 'redux/modules/databaseSearches/sets/path'

const clearForm = formName => (dispatch, getState) => {
  const unitType = getState().projectSummary.get('unitType')
  const initialValues = getInitialValues(unitType)
  dispatch(initialize(formName, initialValues))
}

export default clearForm
